/*
 * JS for promotion modal. The promotion modal appears after the page has loaded.
 * A user sees the modal only once. It sends a request after show to mark the promotion as viewed.
 */

import $ from 'jquery'
import { addAlertViewEvent } from 'application/ga_alert_view_event'

const MODAL_SELECTOR = '#promotion-modal'

function init() {
  const $promotionModal = $(MODAL_SELECTOR)
  if ($promotionModal.length) {
    SOPHIA.overlayBox($promotionModal, {
      baseClass : 'full-page',
      clickSlide: false,
      notToClone: true,
      afterLoad: () => {
        $('.promotion-code-p a', $promotionModal).on('click', (e) => {
          e.preventDefault()
          const $code = $(".promotion-code-to-copy", $promotionModal);
          const $temp = $("<input class='copy-to-clipboard-code'>");
          $("body").append($temp);
          $temp.val($code.text()).select();
          document.execCommand("copy");
          $temp.remove();
        })
      },
      afterShow: () => {
        markViewed();
        gaSendAlertViewEvent();
      }
    });
  }
}

function gaSendAlertViewEvent() {
  const discount_value = $(MODAL_SELECTOR).data('discount')

  const ga_alert_view_data = {
    alert_name: discount_value + " off",
    alert_id: $(MODAL_SELECTOR).data('promotion-id'),
    event_detail: "promotion modal"
  }

  addAlertViewEvent(ga_alert_view_data)
}

/*
 * Marks the promotion as viewed
 */
function markViewed() {
  SOPHIA.ajax({
    data: { name: 'promotion_modal_viewed' },
    dataType: 'json',
    method: 'PUT',
    url: SOPHIA.Routes.soft_update_user_path(SOPHIA.currentUserSlug())
  });
}

$(() => {
  // Init the promotion on the next tick.
  // It's needed if the page contains other modals that open after the page has loaded.
  setTimeout(() => {
    init()
  }, 5000)
})
